import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/illustrations/not_found.png'


const _withScopeId = n => (_pushScopeId("data-v-df3b809e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__record px-10 pb-30 md-down:px-4" }
const _hoisted_2 = { class: "__record__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_3 = { class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "__record__content"
}
const _hoisted_6 = { class: "__record__intro flex flex-nowrap items-end justify-between xl-down:flex-col xl-down:items-stretch gap-8" }
const _hoisted_7 = { class: "flex flex-nowrap md-down:mb-8 md-down:mr-0 mb-0 items-stretch gap-4" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 text-neutral-400 mb-3\" data-v-df3b809e><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-df3b809e><path d=\"M16.8354 15.4634C15.9466 14.0316 13.9944 12.5 10.0002 12.5C6.00601 12.5 4.05388 14.0316 3.16504 15.4634C4.7685 17.4668 7.23451 18.75 10.0002 18.75C12.7659 18.75 15.2319 17.4668 16.8354 15.4634Z\" fill=\"currentColor\" data-v-df3b809e></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 11.25C12.0711 11.25 13.75 9.57107 13.75 7.5C13.75 5.42893 12.0711 3.75 10 3.75C7.92893 3.75 6.25 5.42893 6.25 7.5C6.25 9.57107 7.92893 11.25 10 11.25Z\" fill=\"currentColor\" data-v-df3b809e></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"currentColor\" data-v-df3b809e></path></svg><div class=\"text-neutral-500 text-sm\" data-v-df3b809e> Tổng nhân sự </div></div>", 1)
const _hoisted_9 = { class: "font-bold text-4xl text-neutral-700 mt-1" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 text-green-500 mb-3\" data-v-df3b809e><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-df3b809e><path d=\"M16.8354 15.4634C15.9466 14.0316 13.9944 12.5 10.0002 12.5C6.00601 12.5 4.05388 14.0316 3.16504 15.4634C4.7685 17.4668 7.23451 18.75 10.0002 18.75C12.7659 18.75 15.2319 17.4668 16.8354 15.4634Z\" fill=\"currentColor\" data-v-df3b809e></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 11.25C12.0711 11.25 13.75 9.57107 13.75 7.5C13.75 5.42893 12.0711 3.75 10 3.75C7.92893 3.75 6.25 5.42893 6.25 7.5C6.25 9.57107 7.92893 11.25 10 11.25Z\" fill=\"currentColor\" data-v-df3b809e></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"currentColor\" data-v-df3b809e></path></svg><div class=\"text-neutral-500 text-sm mt-1\" data-v-df3b809e> Đang kích hoạt </div></div>", 1)
const _hoisted_11 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 text-sienna-500 mb-3\" data-v-df3b809e><svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-df3b809e><path d=\"M16.8354 15.4634C15.9466 14.0316 13.9944 12.5 10.0002 12.5C6.00601 12.5 4.05388 14.0316 3.16504 15.4634C4.7685 17.4668 7.23451 18.75 10.0002 18.75C12.7659 18.75 15.2319 17.4668 16.8354 15.4634Z\" fill=\"currentColor\" data-v-df3b809e></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 11.25C12.0711 11.25 13.75 9.57107 13.75 7.5C13.75 5.42893 12.0711 3.75 10 3.75C7.92893 3.75 6.25 5.42893 6.25 7.5C6.25 9.57107 7.92893 11.25 10 11.25Z\" fill=\"currentColor\" data-v-df3b809e></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 1.25C5.16751 1.25 1.25 5.16751 1.25 10C1.25 14.8325 5.16751 18.75 10 18.75C14.8325 18.75 18.75 14.8325 18.75 10C18.75 5.16751 14.8325 1.25 10 1.25ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z\" fill=\"currentColor\" data-v-df3b809e></path></svg><div class=\"text-neutral-500 text-sm\" data-v-df3b809e> Chưa kích hoạt </div></div>", 1)
const _hoisted_13 = { class: "font-bold text-4xl text-neutral-700 mt-1" }
const _hoisted_14 = { class: "search-input" }
const _hoisted_15 = { class: "input-group input--lg" }
const _hoisted_16 = { class: "input-icon absolute top-1/2" }
const _hoisted_17 = {
  key: 0,
  class: "shadow-sm sm:rounded-2xl mt-12 overflow-hidden"
}
const _hoisted_18 = { class: "__record__table overflow-x-auto scroll-bar" }
const _hoisted_19 = { class: "overflow-hidden sm:rounded-t-2xl w-fit min-w-full" }
const _hoisted_20 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-neutral-100 h-16" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
    }, " STT "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-32 whitespace-nowrap"
    }, " Tên trị liệu viên "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Chức vụ "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Trạng thái "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
    }, " Liên hệ ")
  ])
], -1))
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "px-6 py-4 text-neutral-700" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_25 = { class: "flex items-center" }
const _hoisted_26 = { class: "relative" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_29 = {
  key: 2,
  style: {"background-color":"rgba(\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t99,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t144,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t195,\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t0.5\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t)"},
  class: "absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 h-6 w-6 rounded-full flex items-center justify-center"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z",
    fill: "#FAF5F1"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "ml-4 text-blue-600 font-semibold whitespace-pre-wrap w-40" }
const _hoisted_33 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_35 = {
  key: 0,
  class: "flex-nowrap flex items-center"
}
const _hoisted_36 = {
  key: 0,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z",
  fill: "#41BEAD"
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.83333 9.16667C5.48815 9.16667 5.20833 9.53976 5.20833 10C5.20833 10.4602 5.48815 10.8333 5.83333 10.8333H14.5833C14.9285 10.8333 15.2083 10.4602 15.2083 10C15.2083 9.53976 14.9285 9.16667 14.5833 9.16667H5.83333Z",
  fill: "#E68D7B"
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "text-neutral-500 ml-4" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "px-6 py-4 whitespace-nowrap text-neutral-700" }
const _hoisted_46 = {
  key: 1,
  class: "w-full h-full mt-20 flex items-center justify-center flex-col"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  height: "250",
  width: "250"
}, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-neutral-500 text-lg text-center",
  style: {"max-width":"700px"}
}, " Không có nhân sự nào trong mục này ", -1))
const _hoisted_49 = [
  _hoisted_47,
  _hoisted_48
]
const _hoisted_50 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InviteEmployee = _resolveComponent("InviteEmployee")!
  const _component_SendInvite = _resolveComponent("SendInvite")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalType === _ctx.ModalType.INVITE)
          ? (_openBlock(), _createBlock(_component_InviteEmployee, {
              key: 0,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalIsOpen = false)),
              onSubmit: _ctx.createStaff,
              invited: _ctx.createdData,
              "onUpdate:invited": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createdData) = $event)),
              inProgress: _ctx.inProgress,
              "onUpdate:inProgress": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inProgress) = $event)),
              "error-prop": _ctx.errorCreateStaff,
              "onUpdate:error-prop": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.errorCreateStaff) = $event))
            }, null, 8, ["onSubmit", "invited", "inProgress", "error-prop"]))
          : _createCommentVNode("", true),
        (_ctx.modalType === _ctx.ModalType.SEND_EMAIL)
          ? (_openBlock(), _createBlock(_component_SendInvite, {
              key: 1,
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalIsOpen = false)),
              staff: _ctx.staffSendInvite,
              onSubmit: _ctx.sendInvite,
              onResend: _ctx.resendInvite,
              invited: _ctx.invited,
              "onUpdate:invited": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.invited) = $event)),
              inProgress: _ctx.inProgress,
              "onUpdate:inProgress": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inProgress) = $event)),
              error: _ctx.error,
              "onUpdate:error": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.error) = $event))
            }, null, 8, ["staff", "onSubmit", "onResend", "invited", "inProgress", "error"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_DaIcon, {
            name: "das--person",
            class: "mr-3 h-6 w-6"
          }),
          _createTextVNode(" Hồ sơ nhân sự ")
        ]),
        (_ctx.isAdmin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "button-p text-center mt-6 w-32",
                onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openModalCreate && _ctx.openModalCreate(...args)))
              }, " Thêm tài khoản ")
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.state = '')),
                  class: _normalizeClass([{
							'border border-yellow-500 bg-yellow-50':
								_ctx.state === '',
						}, "cursor-pointer __record__intro-section p-6 shadow-sm rounded-xl w-56 bg-white"])
                }, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.count.total || 0), 1)
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.state = 'active')),
                  class: _normalizeClass([{
							'border border-yellow-500 bg-yellow-50':
								_ctx.state === 'active',
						}, "__record__intro-section p-6 shadow-sm rounded-xl w-56 bg-white"])
                }, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(Number(_ctx.count.active || 0)), 1)
                ], 2),
                _createElementVNode("div", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.state = 'inactive')),
                  class: _normalizeClass([{
							'border border-yellow-500 bg-yellow-50':
								_ctx.state === 'inactive',
						}, "__record__intro-section p-6 shadow-sm rounded-xl w-56 bg-white"])
                }, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.count.inactive + _ctx.count.closed || 0), 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Gõ tên nhân sự để bắt đầu tìm kiếm",
                    class: "bg-white input-with-icon",
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    onKeyup: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.searching && _ctx.searching(...args))),
                    onKeypress: _cache[15] || (_cache[15] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_DaIcon, {
                      name: "das--search",
                      class: "h-4 w-4 text-neutral-400"
                    })
                  ])
                ])
              ])
            ]),
            (_ctx.staffListFilters.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("table", _hoisted_20, [
                        _hoisted_21,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffListFilters, (person, personIdx) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              onClick: ($event: any) => (
										_ctx.$router.push({
											name: _ctx.routerName.RECORD_EMPLOYEE_DETAIL,
											params: {
												id: person.id,
											},
										})
									),
                              key: person.id,
                              class: _normalizeClass([
										personIdx % 2 === 0
											? 'bg-white'
											: 'bg-neutral-50'
									, "text-neutral-700 hover:bg-orange-50 cursor-pointer"])
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(personIdx + 1), 1)
                              ]),
                              _createElementVNode("td", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    (
														person?.profile_photo
															?.w200
													)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                          src: 
														person?.profile_photo
															?.w200
													,
                                          alt: ""
                                        }, null, 8, _hoisted_27))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                          style: _normalizeStyle({
														background:
															person
																?.profile_photo
																?.default
																?.color,
													})
                                        }, [
                                          _createElementVNode("span", _hoisted_28, _toDisplayString(person
																?.profile_photo
																?.default
																?.initial), 1)
                                        ], 4)),
                                    (
														person.state ===
														'closed'
													)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(person.name), 1)
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$filters.role(person.role)), 1)
                              ]),
                              _createElementVNode("td", _hoisted_34, [
                                (
												_ctx.statusLabel(person.state) !== ''
											)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      (person.state === 'active')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _hoisted_38))
                                        : _createCommentVNode("", true),
                                      (person.state === 'closed')
                                        ? (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_41))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.statusLabel(person.state)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (
												person.state === 'invited' &&
												_ctx.isAdmin
											)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "button-p btn--ghost w-36",
                                      onClick: _withModifiers(($event: any) => (_ctx.openModalSen(person)), ["stop"])
                                    }, " Gửi lại liên kết ", 8, _hoisted_43))
                                  : _createCommentVNode("", true),
                                (
												person.state === 'created' &&
												_ctx.isAdmin
											)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "button-p w-36",
                                      onClick: _withModifiers(($event: any) => (_ctx.openModalSen(person)), ["stop"])
                                    }, " Gửi lời mời liên kết ", 8, _hoisted_44))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("td", _hoisted_45, [
                                _createElementVNode("div", null, _toDisplayString(person.phone_number), 1)
                              ])
                            ], 10, _hoisted_22))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_46, _hoisted_49))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}